export default __webpack_public_path__ + "static/media/telegram.a6b2b9a5.svg";